import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./SkeletonLoader.css";

function SkeletonLoader(props) {
  const number_of_cards = props.number_of_cards;
  return (
    <section>
      {/* <h2 className="section-title">
        <Skeleton duration={1} height={30} width={`100%`} />
      </h2> */}
      <SkeletonTheme color="#6c757d" highlightColor="#495057">
        <ul className="list ">
          {Array(number_of_cards)
            .fill()
            .map((item, index) => (
              <li className="card bg-dark" key={index} >
                {/* <Skeleton height={180} /> */}
                <h4 className="card-title ">
                  <Skeleton circle={true} height={50} width={50} color="gray" highlightColor="black"/> &nbsp;
                  <Skeleton height={36} width={`90%`} />
                </h4>
                {/* <p className="card-channel">
                  <Skeleton width={`60%`} />
                </p> */}
                <div className="card-metrics ">
                  <Skeleton height={36} width={`95%`} />
                </div>
              </li>
            ))}
        </ul>
      </SkeletonTheme>
    </section>
  );
}

export default SkeletonLoader;
